<template>
  <div>
    <NavigationBreadcrumb :items="breadcrumb_items"></NavigationBreadcrumb>
    <div>
      <h3 class="title-header noprint mt-3">
        {{
          $getVisibleNames(
            "manual.evidencia_de_desempeño",
            true,
            "Evidencias de Desempeño"
          )
        }}
        <AlternativeNameButton
          :table_name="'manual.evidencia_de_desempeño'"
          :allows_crud="allows_crud"
        ></AlternativeNameButton>
      </h3>
      <div style="display: flex">
        <div class="col" style="text-align: left">
          <ButtonMedium
            v-can="'mesh.add_procedureevidence'"
            v-if="allows_crud"
            :tooltip_text="
              $t('reusable.common.addTooltip', {
                entity: $getVisibleNames(
                  'manual.evidencia_de_desempeño',
                  false,
                  'Evidencia de Desempeño'
                ),
              })
            "
            :text_button="$t('reusable.common.add')"
            :click_button="() => $bvModal.show(`new-procedure-evidence-modal`)"
            :icon="'plus'"
            :variant="'primary'"
          >
          </ButtonMedium>
        </div>
      </div>
      <GenericBTable
        :items="procedure_evidences"
        :filterCustom="filterCustom"
        @emitChangeSearchField="changeInputSearch"
        :fields="procedureEvidenceFields"
        :filter="input_search"
        :show_pagination="true"
        :search_filter="true"
        :columns_display="true"
        :allows_crud="allows_crud"
        :display_id="'procedure_evidences'"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
      >
        <template #cell(description)="row">
          <RenderVHtml :content="row.item.description"></RenderVHtml>
        </template>
        <template v-if="allows_crud" #cell(actions)="row">
          <ButtonSmall
            v-can="'mesh.change_procedureevidence'"
            :tooltip_text="
              $t('reusable.common.editTooltip', {
                entity: $getVisibleNames(
                  'manual.evidencia_de_desempeño',
                  false,
                  'Evidencia de Desempeño'
                ),
              })
            "
            :click_button="
              () =>
                $bvModal.show(`edit-procedure-evidence-modal-${row.item.id}`)
            "
            :class="``"
            :icon="'square'"
          ></ButtonSmall>
          <ButtonSmall
            v-can="'mesh.delete_procedureevidence'"
            :click_button="() => askForDeleteProcedureEvidence(row.item.id)"
            :tooltip_text="
              $t('reusable.common.deleteTooltip', {
                entity: $getVisibleNames(
                  'manual.evidencia_de_desempeño',
                  false,
                  'Evidencia de Desempeño'
                ),
              })
            "
            :icon="'trash'"
          ></ButtonSmall>
          <b-modal
            :id="`edit-procedure-evidence-modal-${row.item.id}`"
            :title="$t('toolbar.procedureEvidence.editEvidence')"
            size="lg"
            hide-footer
          >
            <ProcedureEvidenceForm
              :ProcedureEvidence="row.item"
              @updated="slotUpdatedProcedureEvidence"
              :institution_id="row.item.school"
              :show_title="false"
            ></ProcedureEvidenceForm>
          </b-modal>
        </template>
      </GenericBTable>
    </div>
    <b-modal
      :id="`new-procedure-evidence-modal`"
      :hide-footer="true"
      :title="
        $t('reusable.common.createModalTitle', {
          entity: $getVisibleNames(
            'manual.evidencia_de_desempeño',
            false,
            'Evidencia de Desempeño'
          ),
        })
      "
      size="lg"
    >
      <ProcedureEvidenceForm
        v-if="user"
        @created="slotCreatedProcedureEvidence"
        :institution_id="user.school"
      ></ProcedureEvidenceForm>
    </b-modal>
  </div>
</template>
<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import { toast } from "@/utils/utils";

export default {
  name: "ProcedureEvidenceView",
  components: {
    ProcedureEvidenceForm: () => import("./ProcedureEvidenceForm"),
    GenericBTable: () => import("@/components/reusable/GenericBTable"),
    AlternativeNameButton: () =>
      import("@/components/reusable/AlternativeNameButton"),
    ButtonSmall: () =>
      import("@/components/reusable/Buttons/Small/ButtonSmall"),
    ButtonMedium: () =>
      import("@/components/reusable/Buttons/Medium/ButtonMedium"),
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
    NavigationBreadcrumb: () =>
      import("@/components/reusable/NavigationBreadcrumb"),
  },
  data() {
    return {
      input_search: "",
      sortBy: "",
      sortDesc: false,
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      procedure_evidences: names.PROCEDURE_EVIDENCES,
    }),
    breadcrumb_items() {
      return [
        { text: this.$t("reusable.breadcrumb.home"), to: "/home" },
        {
          text: this.$getVisibleNames(
            "manual.evidencia_de_desempeño",
            true,
            "Evidencias de Desempeño"
          ),
        },
      ];
    },
    allows_crud() {
      const has_permission = this.$hasPermissions("mesh.add_procedureevidence");
      if (has_permission) return has_permission;
      else return false;
    },
    procedureEvidenceFields() {
      return [
        {
          key: "name",
          label: String(
            this.$getVisibleNames(
              "manual.evidencia_de_desempeño",
              true,
              "Evidencias de Desempeño"
            )
          ),
          sortable: true,
          tdClass: "text-left",
          display_column: true,
        },
        {
          key: "description",
          label: this.$t("reusable.common.description"),
          sortable: true,
          tdClass: "text-left",
          display_column: true,
        },
        {
          key: "actions",
          label: "",
          display_column: true,
          thClass: "noprint",
          tdClass: "noprint",
        },
      ];
    },
  },
  methods: {
    filterCustom(row) {
      if (
        this.$filtered(row.name, this.input_search) ||
        this.$filtered(row.description, this.input_search)
      ) {
        return true;
      } else return false;
    },
    changeInputSearch(input_search) {
      this.input_search = input_search;
    },
    slotCreatedProcedureEvidence() {
      this.$bvModal.hide("new-procedure-evidence-modal");
    },
    slotUpdatedProcedureEvidence(procedure_evidence) {
      this.$bvModal.hide(
        `edit-procedure-evidence-modal-${procedure_evidence.id}`
      );
    },
    askForDeleteProcedureEvidence(procedure_evidence_id) {
      this.$swal({
        title: this.$t("toolbar.procedureEvidence.deleteEvidenceConfirmation"),
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch(names.DELETE_PROCEDURE_EVIDENCE, procedure_evidence_id)
            .then(() => {
              toast(this.$t("toolbar.procedureEvidence.evidenceDeleted"));
            });
        }
      });
    },
  },
  beforeDestroy() {
    this.$store.commit(names.MUTATE_DELETE_FILTER_INTELLIGENCE);
    this.$store.commit(names.MUTATE_SHOW_INTELLIGENCE_SIDEBAR, false);
    this.$store.commit(names.MUTATE_DELETE_RULES_FILTER_SELECTOR);
  },
  mounted() {},
  created() {
    this.sortBy = "name";
    this.$store.dispatch(names.FETCH_PROCEDURE_EVIDENCES);
    this.$nextTick(() => {
      this.$store.commit(names.MUTATE_SHOW_INTELLIGENCE_SIDEBAR, true);
      this.$store.commit(names.MUTATE_RULES_FILTER_SELECTOR, {
        visible_intelligence_options: [7],
        disabled_selected_intelligence_option: true,
      });
      this.$store.commit(names.MUTATE_FILTER_INTELLIGENCE, {
        intelligence_option: 7,
      });
    });
  },
};
</script>

<style scoped>
.title-header {
  padding: 0 2rem;
}
.btn-add {
  margin-left: 0.4rem;
  margin-bottom: 0.5rem;
  border-radius: 8px;
  width: 255px;
}
</style>